// src/components/Layout.jsx
import React from 'react';
import Header from './header/Header';
import Footer from './footer/Footer';
import '../dd-redesign.scss';

const Layout = ({ children }) => {
  return (
    <div id="dd-app" className="App">
      <a className="dd-skip-link" href="#main">Skip to main content</a>
      <Header />
      <main id="main" className="App-content" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
